import { ButtonTertiary, IconX, Type, LogoSpotify, IconMinus, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { NotificationIndicator } from '../components/NotificationIndicator';
import { useTranslation } from 'react-i18next';
import { getLineOfBusinessName } from '../i18n/translations';
import { useLineOfBusiness } from '../hooks/useLineOfBusiness';
import { useTextDir } from '../hooks/useTextDir';
const IconButton = styled(ButtonTertiary) `
  color: ${props => props.$iconColor || '#fff'};
`;
const HeaderContainer = styled.div `
  background-color: ${props => props.$backgroundColor || '#3629ed'};
  display: flex;
  height: 5.5rem;
  align-items: center;
  padding: 1.25rem;

  button[aria-label='minimize button']:hover,
  button[aria-label='close button']:hover {
    color: initial;
    opacity: 50%;
  }
`;
const AdvisorInfoContainer = styled.div `
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-inline-end: auto; // push the rest of elements in flexbox to the end
`;
const HeaderLogo = styled(LogoSpotify) `
  fill: ${props => props.$fillColor || '#fff'};
`;
const LogoContainer = styled.div `
  position: relative;
`;
const AdvisorInfoName = styled.div `
  color: #ffffff;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
`;
export const HeaderNotificationIndicator = styled(NotificationIndicator) `
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;
export const ChatBoxHeader = ({ onClose, onMinimizeClicked, disabled, notifications = 0, backgroundColor, titleColor, logoColor, controlColor, }) => {
    const { t } = useTranslation();
    const { lineOfBusiness } = useLineOfBusiness();
    const { dir, formattedMessage } = useTextDir(t('SPOTIFY_FOR_ARTISTS_SUPPORT_TEXT', {
        line_of_business_name: getLineOfBusinessName(lineOfBusiness),
    }));
    return (React.createElement(HeaderContainer, { "$backgroundColor": backgroundColor },
        React.createElement(AdvisorInfoContainer, null,
            React.createElement(LogoContainer, null,
                React.createElement(HeaderLogo, { condensed: true, width: "32", height: "32", "$fillColor": logoColor }),
                notifications > 0 ? (React.createElement(HeaderNotificationIndicator, null, notifications)) : null),
            React.createElement(AdvisorInfoName, null,
                React.createElement(Type, { as: "p", variant: "ballad", style: { color: titleColor }, dir: dir }, formattedMessage))),
        React.createElement(IconButton, { disabled: disabled, "aria-label": "minimize button", "$iconColor": controlColor, iconOnly: IconMinus, onClick: onMinimizeClicked, "data-testid": "chatbox-header-minimize-button" }),
        React.createElement(IconButton, { disabled: disabled, "aria-label": "close button", "$iconColor": controlColor, iconOnly: IconX, onClick: onClose, "data-testid": "chatbox-header-close-button" })));
};
